import { Admin, CustomRoutes, Resource } from 'react-admin';
import { Route } from 'react-router-dom';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import cfg from '../package.json';
import './App.css';
import { authProvider, dataProvider } from './firebase';
import { ConfigsEdit, ConfigsList } from './resources/configs';
import { CountryCreate, CountryEdit, CountryList } from './resources/country';
import { DateCreate, DateEdit, DateList } from './resources/dates';
import { DeviceCreate, DeviceEdit, DeviceList } from './resources/devices';
import { LocationCreate, LocationEdit, LocationList } from './resources/locations';
import { NotificationCreate, NotificationEdit, NotificationsList } from './resources/notifications';
import { PageCreate, PageEdit, PageList } from './resources/pages';
import { PathCreate, PathEdit, PathsList } from './resources/paths';
import { SessionCreate, SessionEdit, SessionList } from './resources/sessions';
import { SettingsEdit, SettingssList } from './resources/settings';
import { SpeakerCreate, SpeakerEdit, SpeakerList } from './resources/speakers';
import { TagCreate, TagEdit, TagsList } from './resources/tags';
import { ExpoInit } from './superAdmin/expos/Init';
import { UserCreate } from './superAdmin/users/Create';
import { UserEdit } from './superAdmin/users/Edit';
import { UserList } from './superAdmin/users/List';
import { IRoles } from './types';
import { getExpoName } from './utils/expoName';

const getResources = ({ roles }: { roles?: IRoles }) => {
  let resources = [] as JSX.Element[][];
  console.log('roles: ', roles);
  if (!roles) {
    roles = {
      config: true,
      dataEntry: true,
      pushNotifs: true,
      settings: true,
      usersAdmin: true,
    };
    // return resources;
  }
  if (roles.dataEntry) {
    resources = resources.concat([
      <Resource name="paths" list={PathsList} edit={PathEdit} create={PathCreate} />,
      <Resource name="tags" list={TagsList} edit={TagEdit} create={TagCreate} />,
      <Resource name="countries" list={CountryList} edit={CountryEdit} create={CountryCreate} />,
      <Resource name="locations" list={LocationList} edit={LocationEdit} create={LocationCreate} />,
      <Resource name="speakers" list={SpeakerList} edit={SpeakerEdit} create={SpeakerCreate} />,
      <Resource name="dates" list={DateList} edit={DateEdit} create={DateCreate} />,
      <Resource name="sessions" list={SessionList} edit={SessionEdit} create={SessionCreate} />,
      <Resource name="pages" list={PageList} edit={PageEdit} create={PageCreate} />,
    ]);
  }
  if (roles.pushNotifs) {
    resources = resources.concat([
      <Resource name="notifications" list={NotificationsList} edit={NotificationEdit} create={NotificationCreate} />,
      <Resource name="devices" list={DeviceList} edit={DeviceEdit} create={DeviceCreate} />,
    ]);
  }
  if (roles.settings) {
    resources = resources.concat([
      <Resource name="settings" list={SettingssList} edit={SettingsEdit} options={{ label: 'Admin Settings' }} />,
    ]);
  }
  if (roles.config) {
    resources = resources.concat([
      <Resource name="configs" list={ConfigsList} edit={ConfigsEdit} options={{ label: 'Conference Config' }} />,
    ]);
  }

  // if (roles.usersAdmin) {
  //   resources = resources.concat([<Resource name="auth" list={ConfigsList} edit={ConfigsEdit} options={{ label: 'Conference Config' }} />]);
  // }

  // console.log('Returning resources  ', resources.length, resources);

  return resources;
};

const expoName = getExpoName();

// console.log('En APP', expoName);
function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div className="App">
        <Admin dataProvider={dataProvider} authProvider={authProvider}>
          {permissions => {
            console.log('permissions', { permissions });
            // TODO: permissions structure??
            return getResources(permissions.expos ? permissions.expos[expoName] : permissions);
          }}
          <CustomRoutes>
            <Route path="/admin-users/create" element={<UserCreate />} />,
            <Route path="/admin-users/:uid" element={<UserEdit />} />,
            <Route path="/admin-users" element={<UserList />} />,
            <Route path="/admin-expos" element={<ExpoInit />} />,
          </CustomRoutes>
          {/* <Resource name="tags" list={ListGuesser} edit={TagEdit} create={TagCreate}  /> */}
        </Admin>
        Version {cfg.version}
      </div>
    </LocalizationProvider>
  );
}

export default App;
